module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"h1":"Регистрация в Deliver","h2":"Заполните форму для бесплатной регистрации"}}')
  delete Component.options._Ctor
}
